import actionTypes from 'SRC/modules/redux/actionTypes'

export const setActiveCategories = categories => ({
  type: actionTypes.SET_ACTIVE_CATEGORIES,
  payload: categories
})
